import { Navigate } from "react-router";
import { isDeviceMobile } from "../../helpers/deviceDetect";

export default function MobileOnly() {
  const isMobile = isDeviceMobile(navigator.userAgent);

  if (isMobile) {
    return <Navigate to="/" />;
  }

  return (
    <div className="card mx-auto w-full max-w-lg p-12 text-center">
      <h1 className="text-red font-bold mb-8">{"Mobile only"}</h1>
      <p className="text-red mx-auto text-center mb-8">
        You can only enter this Costa Express promotion on mobile as we need a
        photo of your receipt.
      </p>
    </div>
  );
}
